import { render, staticRenderFns } from "./OrderListNew.vue?vue&type=template&id=2c55103c"
import script from "./OrderListNew.vue?vue&type=script&lang=js"
export * from "./OrderListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports